<template>
    <v-dialog v-model="shows" width="400">
        <v-card class="purchase-method-noti">
            <v-card-title> 결제 서비스 준비중 </v-card-title>
            <v-card-text class="purchase-method-noti__info">
                <p>해당 결제서비스는 준비중 입니다.</p>
                <p>빠른 시일내에 서비스하겠습니다.</p>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="primary" @click="exit"> 닫기 </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data: () => ({
        shows: false,
    }),
    methods: {
        open() {
            this.shows = true;
        },
        exit() {
            this.shows = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.purchase-method-noti {
    &__info {
    }
}
</style>
